// Vue.js uygulamasını başlatmak için gerekli modülleri içe aktar
import { createApp } from 'vue'
import App from './App.vue'
import store from './store' // Store dosyasının yolu

// Vue uygulamasını oluştur, store'u kullan ve '#app' elementine monte et
createApp(App).use(store).mount('#app')
